import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { injectIntl } from 'react-intl';

import messages from './ZszPolicyView.intl';

import ContentStore from 'stores/Content.store';

import { Container, Title } from 'common/components/Layout/Layout';
import AccordionList from '../../common/components/AccordionList/AccordionList';
import FullWidthBackground from 'common/components/Placeholder/components/FullWidthBackground/FullWidthBackground';
import ImageGreyBackground from 'common/components/ImageGreyBackground/ImageGreyBackground';
import InjectMetaTags from 'common/components/InjectMetaTags/InjectMetaTags';
import Link from '../../common/components/Link/Link';
import Placeholder from 'common/components/Placeholder/Placeholder';

import styles from './ZszPolicy.module.scss';

@injectIntl
@observer
export default class ZszPolicyView extends Component {
  render() {
    const content = ContentStore.content;

    return (
      <div>
        {ContentStore.isLoaded && <InjectMetaTags {...content.zszPolicySEO} />}
        <Container>
          <Title title={this.props.intl.formatMessage(messages.heading)} />
        </Container>
        <Placeholder component={<FullWidthBackground />} ready={!!content}>
          {content && (
            <ImageGreyBackground
              className={styles.BoldHeading}
              source={content.zszPolicyImage}
              alternative="hello"
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: content.zszPolicyText
                }}
              />
            </ImageGreyBackground>
          )}
        </Placeholder>
        {content && (
          <Container>
            <AccordionList accordionList={content.zszPolicyAccordionList} />
            {content.zszPolicyLinks.map(link => (
              <Link
                key={link.id}
                isBlank={link.isBlank === 'true' ? true : false}
                title={link.title}
                url={link.url}
              />
            ))}
          </Container>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/ZszPolicy/ZszPolicyView.js